import React from 'react';
import { Typography, Skeleton } from '@mui/material';
import { flowStateChip, flowSendStates, StepTypeIcon } from '../../../../JourneyConstants';
import useLocalStore from '../../../../../../useLocalStore';

const EditNodeHeader = ({ step }) => {
    const [setSidebar] = useLocalStore((state) => [state.setSidebar]);



    const statusBadge = flowStateChip(step.status, step.has_changes, 'small');

    const canSend = step.has_changes && flowSendStates[step.can_activate];

    const handleSidebar = (event) => {
        const payload = {
            open: true,
            name: 'JourneyStepEdit',
            params: {
                stepId: step.id
            }
        };
        setSidebar(payload);
    };

    return (
        <>
            {step ?
                <div className='flow-node__header'
                     style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                     onClick={handleSidebar}
                >
                    <Typography className='node-icon' style={{width: '100% !important'}}>
                        <StepTypeIcon step={step} color={undefined} />
                    </Typography>
                    <Typography variant='caption' component='div' style={{fontWeight: 400, marginLeft: 7, fontSize: 12, marginRight: 5}}>
                        {step?.description_minimal}
                    </Typography>
                    <Typography variant='caption' component='div' style={{display: 'inline-flex', alignItems: 'center', fontWeight: 500, marginLeft: 'auto', fontSize: 14, marginRight: 0, position: 'absolute', right: 0, background: 'white', paddingLeft: 5, paddingRight: 5}}>
                        {statusBadge}
                        {step.has_changes && canSend}
                    </Typography>
                </div>

                :
                <div className='flow-node__header'>
                    <Typography className='node-icon' style={{width: '100% !important'}}>
                        <Skeleton variant='circular' animation='wave' width={15} height={15} />
                    </Typography>
                    <Typography variant='caption' component='div' style={{fontWeight: 400, marginLeft: 7, fontSize: 14, marginRight: 5}}>
                        <Skeleton animation='wave' width={150} variant='text' />
                    </Typography>
                    <Typography variant='caption' component='div' style={{fontWeight: 500, marginLeft: 'auto', fontSize: 14, marginRight: 0}}>
                        <Skeleton animation='wave' width={50} variant='text' />
                    </Typography>
                </div>
        }
        </>
    );
};

export default EditNodeHeader;
